import { render } from "./Works.vue?vue&type=template&id=9f286ca2&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=9f286ca2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f286ca2"]])

export default __exports__